import '@babel/polyfill';
import { Header } from '../../src/components/Header/Header.js';

new Header(document.getElementById('header'));



// WEBPACK FOOTER //
// ./assets/js/main.js